import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './mystyles.scss'
import './css/iconmonstr-iconic-font.min.css'

Vue.config.productionTip = false

let savedLogin = localStorage.getItem('loginData');
if(savedLogin) {
  let loginData = JSON.parse(savedLogin);
  let expiresDate = new Date(loginData.expires)
  
  if(expiresDate > new Date()) {
    store.commit('login', loginData);
  }
}

window.addEventListener("keyup", function(e) {
  store.dispatch("windowKeyup", e);
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
